import materialpalette from 'material-palette';
import hexToHSL from 'hex-to-hsl';

export const namedPaletteTypesMap = {
  100: 'lightest',
  200: 'lighter',
  300: 'light',
  500: 'base',
  700: 'dark',
  800: 'darker',
  900: 'darkest',
};

/*
 * createPalette(color)
 * accepts a color eg '#000'
 *
 * returns an object of palette types to HSL colors
 *
 * eg: {
 *  lightest: hsl(0, 0, 98%),
 *  ...
 *  500: hsl(0, 0, 50%),
 *  ...
 *  900: hsl(0, 0, 0%),
 *  darkest: hsl(0, 0, 0%),
 * }
*/

const isWhite = (hex) => {
  const color = hex.toLowerCase();
  return color === '#fff' || color === '#ffffff';
};

const createPalette = (hex) => {
  const hsl = hexToHSL(hex);
  const materialColor = materialpalette({ h: hsl[0], s: hsl[1], l: hsl[2] });

  Object.keys(materialColor).forEach((color) => {
    const { h, s, l } = materialColor[color];

    let colorString = `hsl(${h}, ${s}%, ${l >= 98 ? 98 : l}%)`;

    if (isWhite(hex)) {
      colorString = `hsl(${h}, ${s}%, ${l}%)`;
    }

    const namedPalette = namedPaletteTypesMap[color];

    materialColor[color] = colorString;

    if (namedPalette) {
      materialColor[namedPalette] = colorString;
    }
  });

  return materialColor;
};

export default createPalette;



// WEBPACK FOOTER //
// ./src/styles/createPalette.js